// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import type { State } from 'store';
import { BaseActions, UserActions } from 'store/actionCreators';
import storage, { keys } from 'lib/storage';
import UserMobileMenu from 'components/base/UserMobileMenu';
import type { UserData } from 'store/modules/user';

type Props = {
  userMobileMenu: boolean,
  user: ?UserData,
};

class UserMobileMenuContainer extends Component<Props> {
  onLogout = async () => {
    try {
      await UserActions.logout();
      window.Tawk_API.logout();
    } catch (e) {
      console.log(e);
    }
    storage.remove(keys.user);
    window.location.href = '/';
  };

  onClickOutside = () => {
    BaseActions.hideMobileUserMenu();
    document.body.style.overflowY = '';
  };

  render() {
    const { userMobileMenu, user, location } = this.props;
    const { onClickOutside, onLogout } = this;

    return (
      <UserMobileMenu
        logged={!!user}
        onLogout={onLogout}
        onClickOutside={onClickOutside}
        rule={user && user.rule}
        displayName={user && user.displayName}
        username={user && user.username}
        thumbnail={user && user.thumbnail}
        showMobileUserMenu={userMobileMenu}
        eventTypes={['click', 'touchend']}
        location={location}
      />
    );
  }
}

export default connect(
  ({ base, user }: State) => ({
    userMobileMenu: base.userMobileMenu,
    user: user.user,
  }),
  () => ({}),
)(UserMobileMenuContainer);



// WEBPACK FOOTER //
// ./src/containers/base/UserMobileMenuContainer.js